import { FieldItem } from '@visualfabriq/vf-ui-kit/dist/components/molecules/form/form-auto-generated/types';

export const requiredField: Partial<FieldItem> = {
  is_obligatory_field: true,
  validations: {
    required: {
      value: true,
    },
  },
};
